import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { selectIsSearch } from '../redux/features/dashboard/dashboardSelectors';
import { showSearch } from '../redux/features/dashboard/dashboardSlice';
import { useReturnToMain } from '../hooks/useReturnToMain';

import { Container } from '../layouts/Container';
import { ResultsTable } from '../components/ui/ResultsTable';
import { ButtonTemplate } from '../components/ui/buttons/ButtonTemplate';
import { RealtyList } from '../components/ui/RealtyList';
import { Loader } from '../components/ui/Loader';
import { SearchForm } from '../components/form/forms/searchFormComponents/SearchForm';
import { RealtyListSearch } from '../components/ui/RealtyListSearch';

export const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showSort, setShowSort] = useState(false);
  const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const realtyIdParam = searchParams.get('realtyId');
  const hydratedForRealtyId = useRef(null);

  const isSearchShown = useSelector(selectIsSearch);
  const handleReturnToMain = useReturnToMain();

  useEffect(() => {
    setShowAdditionalFilters(isSearchShown);
    setShowSort(isSearchShown);
  }, [isSearchShown]);

  useEffect(() => {
    if (realtyIdParam && hydratedForRealtyId.current !== realtyIdParam) {
      hydratedForRealtyId.current = realtyIdParam;
      dispatch(
        showSearch({
          isSearchVisible: true,
          searchQuery: '',
          searchFilters: `?search_type=1&id=${realtyIdParam}`,
        })
      );
    }
  }, [realtyIdParam, dispatch]);

  return (
    <Container>
      {isSearchShown && (
        <ButtonTemplate
          text={'Return to main'}
          classes={'bg-white border-gray-200 mb-4'}
          handleClick={handleReturnToMain}
        />
      )}

      <SearchForm
        showAdditionalFilters={showAdditionalFilters}
        setShowAdditionalFilters={setShowAdditionalFilters}
        showSort={showSort}
        setShowSort={setShowSort}
      />

      {isSearchShown ? (
        <RealtyListSearch setIsLoading={setIsLoading} />
      ) : (
        <>
          <div className="hide-scroll flex justify-between gap-3 mb-6 overflow-auto w-full lg:overflow-scroll">
            <ResultsTable />
          </div>

          <RealtyList
            isSearch={isSearchShown}
            setIsLoading={setIsLoading}
          />
        </>
      )}

      {isLoading && (
        <div className="absolute top-0 left-0 flex items-center justify-center w-full h-screen bg-whiteColor z-[10]">
          <Loader
            width={40}
            height={40}
          />
        </div>
      )}
    </Container>
  );
};
